module.exports = __webpack_public_path__ + "static/img/main_kefuid.5bd080e8.png";